module.exports = __webpack_public_path__ + "static/media/aurora.f4c2740d.svg";